import { Menu } from "../types/menu";

// 操作メニュー配列
export const menuArray:Array<Menu[]> = [
  [
    {
      name: 'メニュー',
      link: 'MAIN',
      groups: ['all'],
      color: 'green',
    },
    {
      name: '最新状況',
      link: '/home',
      groups: [''],
    },
    {
      name: '最新状況',
      link: '/currentView',
      groups: ['all'],
    },
    {
      name: 'クラウド障害履歴',
      link: '/historyView',
      groups: ['all'],
    },
    {
      name: '問い合わせ履歴',
      link: '/caseView',
      groups: ['necdomain'],
    },
    {
      name: '通知メール履歴',
      link: '/noticeView',
      groups: ['all'],
    },
    {
      name: 'その他関連情報',
      link: '/dashboard',
      groups: ['necdomain'],
    },
  ],
  [
    {
      name: 'テナント管理',
      link: 'MAIN',
      groups: ['exceptExec'],
      color: 'silver',
    },
    {
      name: 'ユーザ登録',
      link: '/addUser',
      groups: [''],
    },
    {
      name: 'ユーザ割り当て',
      link: '/tenantList',
      groups: ['exceptExec'],
    },
  ],
];
